import React from 'react'

const FeatureEngineeringDoc = () => {
  return (
    <div className='container'>
        <h1 className='text-light text-center'>Feature Engineering</h1>

      <p className='text-light'>
        Feature engineering is the process of transforming raw data into
        features that can be used to train machine learning models. An MLGUI
        machine learning graphical user interface web tool could make it easier
        for students and developers to perform feature engineering by providing
        a user-friendly interface for manipulating and transforming data. The
        tool could include features such as data visualization, data
        preprocessing, feature selection and extraction, and feature scaling.
        This would enable users to quickly and easily prepare data for machine
        learning without needing to write complex code.{" "}
      </p>
    </div>
  )
}

export default FeatureEngineeringDoc
